import { Box } from '@domain-group/suit-theme'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'
import type { UseCampaignQuoteItemPayload } from '@hooks/useCampaignQuoteItem'

import Artwork from './Artwork'
import ExternalManagement from './ExternalManagement'
import OrderItemTask from './OrderItemTask'

const featureKeys = [
  'artwork.create',
  'artwork.edit',
  'orderItemTask.manage',
  'provider.deepLink',
] as const

interface OrderItemOrQuoteItemManagementProps {
  boxProps?: object,
  enabledFeatureKeys?: (typeof featureKeys[number])[],
  itemPayload: UseOrderItemPayload | UseCampaignQuoteItemPayload,
  redirectUrl?: string,
}

const OrderItemOrQuoteItemManagement = (props: OrderItemOrQuoteItemManagementProps) => {
  const {
    itemPayload: {
      requiredItems,
    },
  } = props

  return (
    <Box flexDirection="column">
      {/*
       // @ts-expect-error TS2322 */}
      {requiredItems.artwork && <Artwork {...props} />}

      {/*
       // @ts-expect-error TS2339 */}
      {requiredItems.externalManagement && <ExternalManagement {...props} />}

      {/*
       // @ts-expect-error TS2339 */}
      {requiredItems.orderItemTask && (
        // @ts-expect-error TS2322
        <OrderItemTask
          boxProps={{ marginTop: requiredItems.artwork ? 'medium' : null }}
          {...props}
        />
      )}
    </Box>
  )
}

export default OrderItemOrQuoteItemManagement
